import {
  MUSIC_SEARCH,
  SEARCH_RESULTS,
  CURRENT_TRACK,
  ADVANCED_TRACK,
  SEARCH_RESULTS_ADVANCED,
  SEARCH_RESULTS_ADVANCED_START,
  FILTER_OPTIONS,
  SET_PLAYING_TRACK,
  UPDATE_AUDIO_STATE,
  RESET_SEARCH,
  CLEAR_ADVANCED_TRACK_DATA,
  PERFORMING_BASIC_SEARCH,
  HOME_SEARCH_RESULT,
  FOOTER_IS_PAUSED,
  MODAL_IS_OPEN,
  SEARCH_PERFORMED,
  SHOW_ADVANCED_DATA
} from '../constants/action-types';

const InitialState = {
  isCurrentlyPlaying: false,
  audioPlayerState: {
    componentPlaying: '',
    trackID: '',
    isPlaying: false,
    playPause: '',
    playIcon: 'fas fa-play',
    pauseIcon: 'fas fa-pause',
    currentIcon: 'fas fa-play',
    currentTime: '0:00',
    showFooterPlayer: false,
    songSrc: '',
    songProgress: 0,
    stopPlaying: false,
    item: {},
    domRef: null,
  },
  search: '',
  success: null,
  error: null,
  searchResults: null,
  currentTrackBasicData: null,
  loadingBasicSearch: false,
  advancedSuccess: null,
  currentTrackAdvancedData: null,
  footerPlayerCurrentSong: '',
  footerPlayerSong: '',
  footerPlayerPaused: true,
  filterOptions: 'track',
  popularSearchResults: null,
  popularSearchSuccess: null,
  popularSearchError: null,
  popularSearchPending: false,
  modalIsOpen: false,
  searchPerformed: false,
  showAdvancedData: false
};

export default (state = InitialState, action) => {
  console.debug('Search Reducer->', action.type, action);
  switch (action.type) {
    case MUSIC_SEARCH:
      return {
        ...state,
        search: action.payload
      };
    case PERFORMING_BASIC_SEARCH:
      return {
        ...state,
        loadingBasicSearch: action.payload
      };
    case SEARCH_RESULTS:
      return {
        ...state,
        searchResults: action.payload,
        success: action.success,
        error: action.error,
        loadingBasicSearch: false,
      };
    case RESET_SEARCH:
      return {
        ...state,
        search: ''
      };
    case HOME_SEARCH_RESULT:
      return {
        ...state,
        popularSearchResults: action.payload || null,
        popularSearchSuccess: action.success,
        popularSearchError: action.error || null,
        popularSearchPending: action.searching || false,
      };
    case CURRENT_TRACK:
      return {
        ...state,
        currentTrackBasicData: action.payload
      };
    case ADVANCED_TRACK:
      return {
        ...state,
        currentTrackAdvancedData: action.payload,
      };
    case SEARCH_RESULTS_ADVANCED_START:
      return {
        ...state,
        currentTrackAdvancedData: action.payload,
        advancedSuccess: false,
        error: null,
      };
    case SEARCH_RESULTS_ADVANCED:
      return {
        ...state,
        currentTrackAdvancedData: action.payload,
        currentTrackBasicData: action.payload.meta.data,
        advancedSuccess: action.success,
        error: action.error,
      };
    case CLEAR_ADVANCED_TRACK_DATA:
      return {
        ...state,
        currentTrackAdvancedData: null,
        advancedSuccess: null
      };
    case FILTER_OPTIONS:
      return {
        ...state,
        filterOptions: action.payload
      };
    case SET_PLAYING_TRACK:
      return {
        ...state,
        isCurrentlyPlaying: action.payload
      };
    case UPDATE_AUDIO_STATE:
      console.log("Search Reducer:->", action.type, 'payload', action.payload, 'merged', {
        ...state,
        audioPlayerState: {
          ...state.audioPlayerState,
          ...action.payload
        }
      });
      return {
        ...state,
        audioPlayerState: {
          ...state.audioPlayerState,
          ...action.payload
        }
      };
    case FOOTER_IS_PAUSED:
      return {
        ...state,
        footerPlayerPaused: action.payload
      }
    case MODAL_IS_OPEN:
      return {
        ...state,
        modalIsOpen: action.payload
      }
    case SEARCH_PERFORMED:
      return {
        ...state,
        searchPerformed: action.payload
      }
    case SHOW_ADVANCED_DATA:
      return {
        ...state,
        showAdvancedData: action.payload
      }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/store/reducers/search-reducer.js